import { MenuOutlined, CloseOutlined } from "@ant-design/icons";
import icon from "./Picture2.svg";

export const BrandLogo = ({ title = "Aispire 360", isOpen = false, onToggle }) => {
  return (
    <div className="flex items-center">
      <button
        aria-label={isOpen ? "Close menu" : "Open menu"}
        onClick={onToggle}
        style={{ background: "transparent", border: 0, padding: 0, margin: 0, cursor: "pointer" }}
      >
        {isOpen ? (
          <CloseOutlined style={{ color: "white", fontSize: 26 }} />
        ) : (
          <MenuOutlined style={{ color: "white", fontSize: 26 }} />
        )}
      </button>

      <div style={{ display: "flex", alignItems: "center", marginLeft: 30 }}>
        <img src={icon} alt="Icon" style={{ height: 40, width: 40 }} />
        <span className="text-[22px]/[28px] font-semibold text-white ml-2">
          <span style={{ color: "#1677ff" }}>AIspire</span>
          <span style={{ color: "#df6c64", marginLeft: 1, marginTop: 4 }}>360</span>
        </span>
      </div>
    </div>
  );
};
